export default __webpack_public_path__ + "static/media/newhero3.c0477f3b.webm";